module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-bodymatter element-type-chapter element-with-heading",
    attrs: {
      "id": "vol-1-chapter-2"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "vol-1-chapter-2-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Two")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "vol-1-chapter-2-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("G")]), _vm._v("arrison squeezed the handle of the open truck door like he clutched a roped steer. The familiar scents of the ranch welcomed him home. Dirt, hay, fresh air, and the sting of frigid air that heralded the cold front coming in tonight.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The Gros Ventre mountains with their snow-topped peaks reached up to the heavy, gray skies. Snow due tonight. Too early this year.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Shit. He had way too much to do before winter hit. The fresh air soured in his chest, and he let it out with an unhappy"), _c('i', [_vm._v(" whoosh. ")]), _vm._v("Outside held cold and endless work. Inside the sprawling ranch house, with its large, handcrafted logs and glow of light, were more tasks he would rather avoid.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("What the hell was he supposed to do about Zach? Was his son starting to manifest an ability like Garrison’s? Damn it.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He lurched out of the truck and slammed the door, resting his fist on the icy metal.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Son of a bitch, he didn’t have time for psychology mumbo jumbo. Any rational human could see that Zach was perfectly fine.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Anyone but his nosy teacher.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Worst of all, he’d bent his own rules today and used his ability to detect the truth back in that classroom—the same ability he should have fully used on his ex-wife last year. But who would have thought his wife would betray him?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The same guy who now thought his son’s teacher would lie to him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Hell, he didn’t care how bad Sara’s and his heads had ached afterward; he needed to know if she was telling the truth about Zach and about her relationship with the Brands.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Damn it all if her aura didn’t glow a bright, confident pink. Not lying. Utterly sincere.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sara Lopez. From the hint of a mischievous dimple in one cheek down to her ample curves, she personified everything Garrison wasn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He had no rounded edges. No gentle approach. No soft touch.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And he’d hurt someone who didn’t deserve it.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Wretched power. Good only for invasion of privacy and continuous paranoia. Great.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("So Sara was completely correct: What she did in her spare time was none of his goddamned business.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Even if he found himself a little curious about her personal life.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But not jealous.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He pressed his fist harder against the icy metal of the truck.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Bottom line: he had doubted someone. Again.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sparing a brief glance at the cloud-covered mountains to the north and west, he pushed off the truck. On his way up the steps to the porch, he paused.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Instead of enjoying the clean mountain air and the lowing of distant cattle, instead of appreciating the handcrafted knotty wood beams and soaring roofline, all he saw was the looming to-do list from hell. And problems. Craploads of problems.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Stomping up the front porch steps, he pushed open the heavy wood door.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Dad!” Zach slid on socked feet as he tried to stop near the front door but missed and bumped into the opposite wall. Seemingly unaffected, he bounced back in front of Garrison and grinned.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("How had he not noticed that his son’s curly, red hair had grown into an unruly mop? Time for a haircut.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Add another item to the to-do list.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("An invisible vice clamped onto his heart and squeezed. His son wasn’t something to check off a list.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Zach chattered away as he held on to the living room doorjamb and ran in place on the smooth floor. “Did you meet Ms. Lopez? Isn’t she nice? Did she tell you I got two stars on my art project? Did she?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Garrison eased the door closed, placed his hat on the hook, and took a deep breath. An eight-year-old with unlimited energy was a force to be reckoned with. What he’d give to harness that exuberance.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He rubbed his neck. “Yes, son. She is a very nice lady. Smart, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Does she like me?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("In spite himself, he smiled. “Of course she likes you.” He crossed his arms. “But she also talked about your behavior.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Zach’s open, grinning face crumpled.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“What behavior?” Zach said. “I listen. I have good marks for staying in my seat. Um, and I only get marked down for talking "), _c('i', [_vm._v("sometimes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Shit, he sucked at this parenting thing. “Uh, did she ever say anything about you acting up with the other kids?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Zach stared at the floor. “No.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Want to try that answer again?” He would"), _c('i', [_vm._v(" not")]), _vm._v(" use his ability to find the truth on his own child. Thankfully, he could read his open-book son without the help of any extra powers.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Maybe.” Zach slid his socked toe in an arc on the floor. “Some kids aren’t that nice.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Are they picking on you?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Naw.” The corners of his mouth drawing down canceled out the attempt at a light tone. Bony arms peeked out from the sleeves of the shirt Shelby had bought Zach at the beginning of the school year.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Really?” Garrison asked.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Well, a couple of kids were kind of mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“How?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Nothing.” He stared at the floor, puffed out his cheeks, and blew out the air. “They said stuff about how I don’t have a mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("When Zach raised his head, the depth of sadness in his light brown eyes nailed Garrison like a sucker punch to the jaw. How much had his kid been hiding? How much had he dealt with on his own? What kind of father didn’t see how much Tiffani’s leaving had hurt Zach?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("His son toed the base of the wall. “And about not having a mom? That’s crap.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Garrison snapped. “Who taught you to swear like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("His son’s head whipped around, and he flushed red. “No one,” he mumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Zach…”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Well, Kerr was saying ‘crap’ a bunch when he and Eric were breaking that new horse.” He dropped into a whisper and darted a glance behind him. “They said badder words, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Damn it, Garrison would have to talk with his younger brother, Kerr, about his language in front of Zach. Again. Garrison should talk with Kerr’s business partner and honorary Taggart member, Eric, too. Add that item to the growing to-do list.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“So don’t use that word. Just because other people say bad words doesn’t make it right, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Zach’s pale brow furrowed. “Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“So. What about these kids in school? What happened, and what did you say back?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I said they were dumb, and…”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“And what?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“And I maybe sort of pushed one of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Sort of?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Really did,” he whispered. Even his ears turned red.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Remember what we talked about, duck and water?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Yeah, their words are water and I’m a duck, and those words just slide right off me and go into the pond.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“So can you work on that more?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Even though Zach had agreed with him, why did he feel like his son was still going to slug the next bastard who mocked him? Garrison’s college major was business, not child psychology, damn it.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Silence stretched between them. Zach licked his lips. “So, um, want dinner?” Good grief, now his son had to throw him a bone. Garrison wouldn’t win parent of the year any time soon.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17368195","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vol-001-chapter-002.vue
// module id = 72
// module chunks = 0